import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomerBundle } from 'api/optimalprint-sdk.d';

export type CustomerState = {
  customerData?: CustomerBundle.Entity.API.Profile.CustomerProfileV1Response.IPersonalInfo | null;
};

export const customerInitialState: CustomerState = {
  customerData: null,
};

export const slice = createSlice({
  name: 'customer',
  initialState: customerInitialState,
  reducers: {
    setCustomerData: (
      state,
      action: PayloadAction<CustomerBundle.Entity.API.Profile.CustomerProfileV1Response.IPersonalInfo>,
    ) => {
      state.customerData = action.payload;
    },
  },
});

export const { setCustomerData } = slice.actions;
const { reducer } = slice;
export default reducer;
